import axios from 'axios';

const fetchHistory = async () => {
    try {
        const token = localStorage.getItem('token'); // Usando localStorage para o navegador
        const response = await axios.get('https://apem.riderup.uk/api/listHistory', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar histórico:', error);
        return [];
    }
};

export default fetchHistory;
